module.exports = __webpack_public_path__ + "img/Bank-BRI.8327ece8.jpg";